import { Td, Tr } from '@twilio-paste/core/table';

import { TargetAuthHeaderFormValue } from '../types';

import { TargetAuthHeaderTableRowActions } from './TargetAuthHeaderTableRowActions';

interface TargetAuthHeaderRowProps {
  authHeader: TargetAuthHeaderFormValue;
}

export function TargetAuthHeaderTableRow({ authHeader }: TargetAuthHeaderRowProps) {
  return (
    <Tr>
      <Td>{authHeader.name}</Td>
      <Td>*******************</Td>
      <Td>
        <TargetAuthHeaderTableRowActions authHeader={authHeader} />
      </Td>
    </Tr>
  );
}
